export const SET_QUEUE_COUNT = 'SET_QUEUE_COUNT'

export const setQueueCount = payload => dispatch =>
  dispatch({
    type: SET_QUEUE_COUNT,
    payload,
  })



// WEBPACK FOOTER //
// ./src/modules/queue-count/actions.js